// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AzureAks } from './AzureAks';
import {
  AzureAksFromJSON,
  AzureAksFromJSONTyped,
  AzureAksToJSON,
  AzureAksToJSONTyped,
} from './AzureAks';

/**
 *
 * @export
 * @interface AzureSpec
 */
export interface AzureSpec {
  /**
   *
   * @type {AzureAks}
   * @memberof AzureSpec
   */
  aks?: AzureAks;
  /**
   *
   * @type {object}
   * @memberof AzureSpec
   */
  network?: object;
}

/**
 * Check if a given object implements the AzureSpec interface.
 */
export function instanceOfAzureSpec(value: object): value is AzureSpec {
  return true;
}

export function AzureSpecFromJSON(json: any): AzureSpec {
  return AzureSpecFromJSONTyped(json, false);
}

export function AzureSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureSpec {
  if (json == null) {
    return json;
  }
  return {
    aks: json['aks'] == null ? undefined : AzureAksFromJSON(json['aks']),
    network: json['network'] == null ? undefined : json['network'],
  };
}

export function AzureSpecToJSON(json: any): AzureSpec {
  return AzureSpecToJSONTyped(json, false);
}

export function AzureSpecToJSONTyped(
  value?: AzureSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aks: AzureAksToJSON(value['aks']),
    network: value['network'],
  };
}
